import {
  chakra,
  type BreadcrumbSeparatorProps as ChakraBreadcrumbSeparatorProps,
  defineStyle,
} from '@chakra-ui/react-v2';
import { forwardRef } from 'react';

import { useBreadcrumbStyles } from './context';

export type BreadcrumbSeparatorProps = ChakraBreadcrumbSeparatorProps;

export const BreadcrumbSeparator = forwardRef<'span', BreadcrumbSeparatorProps>(
  function BreadcrumbSeparator(props, ref) {
    const { spacing, ...rest } = props;

    const styles = useBreadcrumbStyles();
    const separatorStyles = defineStyle({
      mx: spacing,
      ...styles.separator,
    });

    return (
      <chakra.span
        ref={ref}
        role="presentation"
        {...rest}
        __css={separatorStyles}
      />
    );
  },
);
BreadcrumbSeparator.displayName = 'BreadcrumbSeparator';
